import { eventLog } from "./eventHelper";
import './TopicSpeakerPreviews.css';


const TopicSpeakerPreviews = ({
    hideTopic,
    playTopic,
    topic,
    overrideSpeakersPerRow,
    showAll,
}) => {
    const speakersPerRow = overrideSpeakersPerRow || 3;
    const maxSpeakers = showAll ? 1000 : speakersPerRow;

    const playTopicClick = (topic, previewId) => () => {
        let preview = null;
        for (let i = 0; i < topic.previews.length; i++) {
            if (topic.previews[i].id === previewId) {
                preview = topic.previews[i];
                break;
            }
        }

        if (preview !== null) {
            eventLog(12, {
                'previewId': preview.id,
                'speakerId': preview.person.id,
                'topicId': topic.id,
            })
        }
        playTopic(topic, previewId)();
    }

    const uniqueSpeakerPreviews = (previews) => {
        const speakerIds = new Set();
        const speakerPreviews = [];
        for (let i = 0; i < previews.length; i++) {
            const preview = previews[i];
            const previewSpeakerId = preview.person.id;
            if (!speakerIds.has(previewSpeakerId)) {
                speakerIds.add(previewSpeakerId)
                speakerPreviews.push(preview);
            }
        }
        return speakerPreviews;
    }

    return (
        <div>
            {!!hideTopic ?
                <></>
                :
                <table style={{ margin: '20px 0px 20px' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '100%' }}>
                                <div style={{ textAlign: 'left', verticalAlign: 'middle' }}>
                                    <div className='subheading'>Trending speakers on "{topic.id}"</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            }
            <div className='topicSpeakerGrid' style={{ gridTemplateColumns: `repeat(${speakersPerRow}, minmax(0, 1fr))` }}>
                {uniqueSpeakerPreviews(topic.previews).slice(0, maxSpeakers).map((preview) => (
                    <button key={preview.person.id} onClick={playTopicClick(topic, preview.id)} className='clampSafeButton topicSpeakerCard'>
                        <img alt='' src={preview.person.imageURL} className='topicSpeakerPortrait' />
                        <div className='profilePictureName'>
                            {preview.person.name}
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TopicSpeakerPreviews;
